import { __assign } from "tslib";
import { makeStyles, shorthands, tokens } from '@fluentui/react-components';
import { CardHeaderHeight, CardHeight, CardPreviewHeight, } from './StyleConstants';
export var useCardStyles = makeStyles({
    headerRoot: {
        boxSizing: 'border-box',
        height: CardHeaderHeight,
        zIndex: 1,
    },
    preview: {
        height: CardPreviewHeight,
        backgroundColor: tokens.colorSubtleBackgroundInvertedSelected,
        zindex: '1',
    },
    previewThumbnail: {
        height: '100%',
        objectFit: 'cover',
        objectPosition: 'center top',
        opacity: '0.93',
    },
    previewErrorThumbnail: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        backgroundColor: tokens.colorNeutralBackground4,
    },
    root: {
        boxSizing: 'border-box',
        height: "".concat(CardHeight),
        cursor: 'pointer',
        ':hover': {
            boxShadow: tokens.shadow8,
        },
        ':hover .show': {
            visibility: 'visible',
        },
        ':focus .show': {
            visibility: 'visible',
        },
        ':focus-within .show': {
            visibility: 'visible',
        },
        ':focus-visible': {
            outlineStyle: 'auto',
        },
        '&:active': {
            boxShadow: tokens.shadow8,
            backgroundColor: 'none',
        },
    },
    headerTitle: {
        color: tokens.colorNeutralForeground1,
    },
    headerSpacing: {
        paddingTop: '6px',
    },
    truncateHeaderText: __assign(__assign({}, shorthands.overflow('hidden')), { whiteSpace: 'nowrap', textOverflow: 'ellipsis' }),
    avatar: {
        width: '32px',
    },
    body: {
        width: '100%',
    },
    headerWithIcon: {
        // First child should be icon
        '> :first-child': {
            minWidth: '30px',
        },
        // 2nd child should be content
        '> :nth-child(2)': {
            minWidth: 0,
        },
    },
    headerWithoutIcon: {
        // First child should be content
        '> :first-child': {
            minWidth: 0,
        },
    },
});
//# sourceMappingURL=RecommendedCardControl.styles.js.map